import { out } from "../output/out";
import { printSession } from "./print-session";
import { sessionOutcome } from "./session-outcome";
import type { SessionDetail } from "./session-detail";

export function writeFollowedSessionOutcome(
  session: SessionDetail,
  asJson: boolean,
): void {
  const outcome = sessionOutcome(session);

  if (asJson) {
    if (!outcome) out.json(session);
  } else {
    out.line();
    printSession(session);
  }

  if (outcome) throw outcome;
}
